import axios from 'axios'

let http = axios.create({
  timeout: 12000,
  baseURL: 'http://proxy.jiankanghao.net:50210',
  //baseURL: 'http://192.168.0.31:9501',
  headers: {'Content-Type': 'application/json'}
});

export default http;


// WEBPACK FOOTER //
// ./src/util/demoApiConfig.js